import { Injectable } from "@angular/core";
import { take } from "rxjs/operators";
import { Subscription } from "rxjs";
import { Store } from "@ngrx/store";
import { GetAllGroups } from "../actions/generics-modules-data.actions";
import { checkSameEvent } from "../selectors/generics-modules-data.selectors";
import { IBaseDocument } from "../interfaces";
import { FirestoreService } from "./firestore.service";
import { where } from "@angular/fire/firestore";
import { getInitSpecificEventDatasPart } from "../selectors/utility.selectors";
import { InitSpecificEventDatasPart } from "../actions/utility.actions";
import { DateTime } from "luxon";

@Injectable({
	providedIn: "root"
})
export class GroupsService {
	groupsSub: Subscription;

	constructor(
		private SFirestore: FirestoreService,
		private store: Store
	) {}

	unsubscribeAll() {
		if (this.groupsSub) {
			this.groupsSub.unsubscribe();
		}
	}

	/**
	 * Get all groups for event
	 * @param eventId
	 * @returns
	 */
	getGroupsForEvent(eventId: string) {
		this.store
			.select(checkSameEvent({ key: "groups", uid: eventId }))
			.pipe(take(1))
			.subscribe((sameEvent) => {
				if (sameEvent && this.groupsSub && !this.groupsSub.closed) {
					return;
				} else if (!sameEvent && this.groupsSub && !this.groupsSub.closed) {
					this.groupsSub.unsubscribe();
				}

				this.groupsSub = this.SFirestore.collectionGroupValueChangesDocuments("groups", [
					where("eventId", "==", eventId)
				]).subscribe({
					next: (groups: any[]) => {
						// this.store.dispatch(GetAllGroups({ payload: groups, eventId: eventId }));

						// this.store
						// 	.select(getInitSpecificEventDatasPart("initGroups"))
						// 	.pipe(take(1))
						// 	.subscribe((init) => {
						// 		if (!init) {
						// 			this.store.dispatch(
						// 				InitSpecificEventDatasPart({ part: "initGroups", payload: true })
						// 			);
						// 		}
						// 	});

						const convertedBaseDocs: IBaseDocument[] = [];
						groups.forEach((group, index) => {
							if (group["id"] && group["datas"] && group["datas"].length > 0) {
								convertedBaseDocs.push(group);
							} else {
								const checkBaseDoc = convertedBaseDocs.find(
									(baseDoc) =>
										baseDoc.eventId === group.eventId && baseDoc.moduleId === group.moduleId
								);
								if (checkBaseDoc) {
									checkBaseDoc.datas.push(group);
								} else {
									const tmpBaseDoc: IBaseDocument = {
										id: "newdoc" + index,
										creationDate: DateTime.local().toISO(),
										eventId: group.eventId,
										moduleId: group.moduleId,
										datas: [group]
									};
									convertedBaseDocs.push(tmpBaseDoc);
								}
							}
						});
						this.store.dispatch(GetAllGroups({ payload: convertedBaseDocs, eventId: eventId }));

						this.store
							.select(getInitSpecificEventDatasPart("initGroups"))
							.pipe(take(1))
							.subscribe((init) => {
								if (!init) {
									this.store.dispatch(
										InitSpecificEventDatasPart({ part: "initGroups", payload: true })
									);
								}
							});
					},
					error: () => {
						//
					}
				});
			});
	}
}
